module.exports = __webpack_public_path__ + "img/middle_9.5e2c6a66.png";